/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'по возрастанию',
  'fabric.editor.headingLink.copied': 'Скопировано!',
  'fabric.editor.headingLink.copyAnchorLink': 'Копировать ссылку в заголовок',
  'fabric.editor.headingLink.copyAriaLabel': 'Скопировать',
  'fabric.editor.headingLink.descSortingLabel': 'по убыванию',
  'fabric.editor.headingLink.failedToCopy': 'Ошибка копирования',
  'fabric.editor.headingLink.noneSortingLabel': 'Нет',
  'fabric.editor.inlineComment.marker.end': 'конец встроенного комментария',
  'fabric.editor.inlineComment.marker.start': 'начало встроенного комментария',
  'fabric.editor.status.accessibilityLabel': 'статус:',
};
